// extracted by mini-css-extract-plugin
export default {"quickReplyButton":"style_quickReplyButton__2Xz98","plusButton":"style_plusButton__adl1c","quickReplybuttonContainer":"style_quickReplybuttonContainer__yDxO7"};